import styled from 'styled-components';
import { DatePickerWrapper, MiniYearWrapper } from '@mlb/react-patterns/v4/components/DatePicker/datePicker.style';
import { MODAL_BREAKPOINT_MOBILE } from '@gameday/components/themes/breakpoints';

export const GamePickerWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    overflow: hidden;

    ${DatePickerWrapper} .react-datepicker-popper {
        z-index: 10;
    }

    ${MiniYearWrapper} {
        box-sizing: content-box;
    }
`;

export const GamePickerMiniContainer = styled.div`
    position: relative;
    display: inline-block;
    width: calc(100% - 100px);

    ${({ gameCardMode }) => {
        if (gameCardMode === 'vertical') {
            return `
                flex: 1;
                overflow: auto;
                width: 100%;
                display: block;
                position: static;
                padding: 0 16px;
                box-sizing: border-box;
            `;
        }
    }};
`;

export const DatePickerOverride = styled.div`
    display: inline-flex;
    vertical-align: top;
    margin-right: 8px;
    margin-top:8px;
    margin-bottom:8px;

    >button {
        height: 74px;
        border: 1px solid var(--gameday-divider-color);
        width: 20px;
        padding: 0px;
        &:first-child {
            border-top-right-radius: 0px;
            border-bottom-right-radius: 0px;
        }
        &:last-child {
            border-top-left-radius: 0px;
            border-bottom-left-radius: 0px;
        }
        svg {
            fill: var(--gameday-primary-font-color);
            path {
                fill: var(--gameday-primary-font-color);
            }
        }

    }
    >button:hover {
        svg {
            fill: var(--gameday-primary-font-color);
            path {
                fill: var(--gameday-primary-font-color);
            }
        }
    }
    .react-datepicker__header,
    .react-datepicker {
        background-color: var(--gameday-background-color);
        border-color: var(--gameday-divider-color);
    }

    label {
        width: 41px;
        padding: 17px 0px;
        height: 38px;
        box-sizing: content-box;
        svg {
            display: none;
        }
        color: var(--gameday-primary-font-color);
        text-transform: uppercase;
        border-radius: 0px;
        border-left-color: transparent;
        border-right-color: transparent;
        border-top-color: var(--gameday-divider-color);
        border-bottom-color: var(--gameday-divider-color);
        div {
            padding: 3px;
            font-size: 14px;
            line-height: 16.41px;
            text-align: center;
        }
    }
    input {
        width: 43px;
        padding: 0px;
        height: 74px;
    }
`;

export const DateWrapper = styled.div`
    flex: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    @media (max-width: ${MODAL_BREAKPOINT_MOBILE}) {
        border-top: 1px solid var(--gameday-divider-color);
    }
    border-bottom: 1px solid var(--gameday-divider-color);
    width: 100%;
    padding: 12px 16px;
    box-sizing: border-box;
    >button {
        border: none !important;
        width: 24px;
        height: 24px;
        padding: 0px;
        svg {
            fill: var(--gameday-primary-font-color);
            path {
                fill: var(--gameday-primary-font-color);
            }
        }
        :hover {
            svg {
                fill: var(--gameday-primary-font-color);
                path {
                    fill: var(--gameday-primary-font-color);
                }
            }
        }
        :disabled {
            background-color: transparent;
            svg {
                fill: var(--gameday-gamepicker-button-disabled) !important;
                path {
                    fill: var(--gameday-gamepicker-button-disabled) !important;
                }
            }
        }
    }
`;

export const DateLabelWrapper = styled.div`
    font-family: var(--gameday-primary-font);
    color: var(--gameday-primary-font-color);
    text-align: center;
    font-size: 16px;
    font-weight: 700;
`;
